var map = {
	"./cn.svg": "2924",
	"./en.svg": "c96f",
	"./es.svg": "7681",
	"./jp.svg": "2318",
	"./ru.svg": "cfd7",
	"./th.svg": "7c38",
	"./vn.svg": "7224"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2a26";